import React from "react";
import UserManagement from "../Pages/DMS/UserManagement/UserManagement";
import CreateUser from "../Pages/DMS/UserManagement/CreateUser/CreateUser";
import ResourceManagement from "../Pages/DMS/ResourceManagement/ResourceManagement";
import RegionManagement from "../Pages/DMS/RegionManagement/RegionManagement";
import CreateRegionForm from "../Pages/DMS/RegionManagement/CreateRegion/CreateRegion";
import ContactManagement from "../Pages/DMS/ContactManagement/ContactManagement";
import CreateContact from "../Pages/DMS/ContactManagement/CreateContact/CreateContact";
import TaskManagement from "../Pages/DMS/TaskManagement/TaskManagement";
import CreateTask from "../Pages/DMS/TaskManagement/CreateTask/CreateTask";
import MyTaskListManagement from "../Pages/DMS/MyTaskListManagement/MyTaskListManagement";
import CreateSOP from "../Pages/DMS/SOPManagement/CreateSOP/CreateSOP";
import SOPManagement from "../Pages/DMS/SOPManagement/SOPManagement";
import RoleManagement from "../Pages/DMS/RoleManagement/RoleManagement";
import CreateRole from "../Pages/DMS/RoleManagement/CreateRole/CreateRole";
import ViewSOP from "../Pages/DMS/SOPManagement/ViewSOP/ViewSOP";
import CreateResource from "../Pages/DMS/ResourceManagement/CreateResource/CreateResource";
import UserTaskManagement from "../Pages/DMS/UserTaskManagement/UserTaskManagement";
import UserTaskForm from "../Pages/DMS/UserTaskManagement/UserTaskForm/UserTaskForm";
import SopInstance from "../Pages/DMS/SOPManagement/SopInstance/SopInstance";
import ExecuteSops from "../Pages/DMS/SOPManagement/ExecuteSops";
import ViewedSopInstance from "../Pages/DMS/SOPManagement/ViewedSopInstance/ViewedSopInstance/ViewedSopInstance";
import DistrictWiseBranchesMain from "../Pages/DMS/Branches/DistrictWiseBranchesMain";
import AllBranches from "../Pages/DMS/Branches/Branches";
import BranchForm from "../Pages/DMS/Branches/AddBranchForm/BranchForm";
import BankForm from "../Pages/DMS/Banks/AddBankForm/BankForm";
import BankManagement from "../Pages/DMS/Banks/BankList/BankManagement";
import IncidentForm from "../Pages/DMS/IncidentManagement/AddIncidentForm/IncidentForm";
import AnnouncementsForm from "../Pages/DMS/InformationCenter/NewAnnouncements/AnnouncementsForm";
import AllAtm from "../Pages/DMS/Atms/AllAtms/AllAtm";
import AtmView from "../Pages/DMS/Atms/ViewData/AtmView";
import EventTypeDetailsMain from "../Pages/DMS/IncidentManagement/AllEvents/EventTypeDetailsMain";
import EventDetailsMain from "../Pages/DMS/IncidentManagement/AllEvents/EventDetailsMain";

import EventForm from "../Pages/DMS/IncidentManagement/CreateEventForm/EventForm";
import ViewIncidetailsMain from "../Pages/DMS/IncidentManagement/AllIncidents/viewIncidentsMain";
import GrievanceMain from "../Pages/DMS/HelpdeskOrGrievance/GrievanceMain";
import ViewBranchDetailsMain from "../Pages/DMS/Branches/AddBranchForm/ViewBranchDetailsMain";
import PublicAnnoncementsMain from "../Pages/DMS/InformationCenter/PublicAnnoncements/PublicAnnoncementsMain";
import ResourceView from "../Pages/DMS/ResourceManagement/ViewResource/ResourceView";
import GisMain from "../Pages/DMS/GisManagement/GisMain";
import DocumentRepoMain from "../Pages/DMS/InformationCenter/DocumentRepository/DocumentRepoMain";
import FoldersContentMain from "../Pages/DMS/InformationCenter/DocumentRepository/FoldersContentMain";
import CircularForm from "../Pages/DMS/InformationCenter/Circulars/CircularForm";
import CircularsMain from "../Pages/DMS/InformationCenter/Circulars/CircularMain";
import ViewContactMain from "../Pages/DMS/ContactManagement/ViewContact/ViewContactMain";
import UserViewmain from "../Pages/DMS/UserTaskManagement/UserView/UserViewmain";
import RaiseTicketMain from "../Pages/DMS/HelpdeskOrGrievance/RaiseTicketMain";
import ViewRiasedTicketMain from "../Pages/DMS/HelpdeskOrGrievance/ViewRiasedTicketMain";
import CreateAnnouncementMain from "../Pages/DMS/InformationCenter/PublicAnnoncements/CreateAnnouncementMain";
import ScheduleAnnouncementMain from "../Pages/DMS/InformationCenter/PublicAnnoncements/ScheduleAnnouncementMain";
import CreateNewDashboard from "../Pages/DMS/DynamicDashboards/NewDashboard";
import QueryBuilder from "../Pages/DMS/DynamicDashboards/queryBuilderForDashboards";
import EnhancedDashboardManager from "../Pages/DMS/DynamicDashboards/DashboardBuilder";
import SavedQueriesList from "../Pages/DMS/DynamicDashboards/saveQueryList";
import EnhancedDashboardManagerForUser from "../Pages/DMS/DynamicDashboards/DashboardBuilderForUser";
import SopsInstance from "../Pages/DMS/SOPManagement/SopInstanceView/SopsInstance";
import ViewBankDetailsMain from "../Pages/DMS/Banks/BankList/BankTable/viewBankDetailsMain";
import AddAtmForm from "../Pages/DMS/Atms/AddAtm/AddAtmForm";
import DistrictWise from "../Pages/DMS/Atms/DistrictWiseAtms/DistrictWise";
import AllIncidentsMain from "../Pages/DMS/IncidentManagement/AllIncidents/AllIncidentsMain";
import GpsTracking from "../Pages/DMS/GpsTrackManagement/GpsTracking";
import GpsTrackView from "../Pages/DMS/GpsTrackManagement/GpsTrackView";
import ExpectedTrackHeader from "../Pages/DMS/ExpectedTrackForm/ExpectedTrackHeader";
import CreateVehicleHeader from "../Pages/DMS/ExpectedTrackForm/CreateVehicleHeader";
// import ApiBuilder from "../Pages/DMS/DynamicDashboards/ApiBuilder";
// import SavedApiQueriesList from "../Pages/DMS/DynamicDashboards/SaveApiQueryList";

import CreateNewDashboardForApi from "../Pages/DMS/DynamicDashboardsForApi/NewDashboard";
import EnhancedDashboardManagerForApi from "../Pages/DMS/DynamicDashboardsForApi/DashboardBuilder";
import EnhancedDashboardManagerForUserForApi from "../Pages/DMS/DynamicDashboardsForApi/DashboardBuilderForUser";
import ApiBuilder from "../Pages/DMS/DynamicDashboardsForApi/ApiBuilder";
import SavedApiQueriesList from "../Pages/DMS/DynamicDashboardsForApi/SaveApiQueryList";
import UserViewMains from "../Pages/DMS/UserManagement/userview/Userviewmain";
import PlannedViewHeader from "../Pages/DMS/PlannedRoute/PlannedViewHeader";
import ManageSlaMain from "../Pages/DMS/HelpdeskOrGrievance/ManageSlaMain";
import GpsTravelViewHeader from "../Pages/DMS/PlannedRoute/GpsTravelViewHeader";
import TripTrackerHeader from "../Pages/DMS/GpsTrackManagement/TripTrackManagement/TripTrackerHeader";
import TripActionHeader from "../Pages/DMS/GpsTrackManagement/TripTrackManagement/TripActionHeader";
import UserDetectionHeader from "../Pages/DMS/UserDetection/UserDetectionHeader";
import AccidentsHistory from "../Pages/DMS/ExpectedTrackForm/AccidentsHistoryMain";
import GeoFencing from "../Pages/DMS/GeoFence/GeoFencing";
import AssignGeofence from "../Pages/DMS/GeoFence/GeofenceManage";
import OTAMain from "../Pages/DMS/OTA/OTAMain";

export const lms_routes_regs = [
  { name: "create-user", component: <CreateUser /> },
  { name: "users", component: <UserManagement /> },
  { name: "roles", component: <RoleManagement /> },
  { name: "create-role", component: <CreateRole /> },
  { name: "user-view-det", component: <UserViewMains /> }
];

export const Dashboard_Dynamic = [
  { name: "dashboardbuilder", component: <EnhancedDashboardManager /> },
  { name: "dashboardbuilderforusers", component: <EnhancedDashboardManagerForUser /> },
  { name: "querybuilder", component: <QueryBuilder /> },
  { name: "Create-dashboard", component: <CreateNewDashboard /> },
  { name: "querylist", component: <SavedQueriesList /> },
  { name: "api-query-list", component: <SavedApiQueriesList /> },
  { name: "apiselector", component: <ApiBuilder /> },
];

export const Dashboard_DynamicForApi = [
  { name: "dashboardbuilderForApi", component: <EnhancedDashboardManagerForApi /> },
  { name: "dashboardbuilderforusersForApi", component: <EnhancedDashboardManagerForUserForApi /> },
  { name: "Create-dashboardForApi", component: <CreateNewDashboardForApi /> },
  { name: "save-api-query-list", component: <SavedApiQueriesList /> },
  { name: "api-builder", component: <ApiBuilder /> },
];

export const configurations = [
  { name: "resource", component: <ResourceManagement /> },
  { name: "create-resource", component: <CreateResource /> },
  { name: "res-view", component: <ResourceView /> }
];

export const region_routes_regs = [
  { name: "region", component: <RegionManagement /> },
  { name: "region-form", component: <CreateRegionForm /> },
];

export const planning_routes_regs = [
  { name: "view-task", component: <TaskManagement /> },
  { name: "Sop-instance-list", component: <SopInstance /> },
  { name: "execute-sops", component: <ExecuteSops /> },
  { name: "create-task", component: <CreateTask /> },
  { name: "view-sop", component: <SOPManagement /> },
  { name: "create-sop", component: <CreateSOP /> },
  { name: "view-sopinfo", component: <ViewSOP /> },
  { name: "sops-instance", component: <SopsInstance /> },
  { name: "viewsops-instance", component: <ViewedSopInstance /> },
];

export const my_tasks_regs = [
  { name: "my-tasks", component: <MyTaskListManagement /> },
  { name: "view-usertask", component: <UserTaskManagement /> },
  { name: "create-usertask", component: <UserTaskForm /> },
  { name: "user-task-view", component: <UserViewmain /> },
];

export const my_gis_mgmnt_regs = [
  { name: "Gis-Map", component: <GisMain /> },
];

export const contact_management = [
  { name: "view-contact", component: <ContactManagement /> },
  { name: "create-contact", component: <CreateContact /> },
  { name: "view-contact-details", component: <ViewContactMain /> }
];

export const information_center = [
  { name: "new-announcements", component: <AnnouncementsForm /> },
  { name: "public-announcements", component: <PublicAnnoncementsMain /> },
  { name: "create-announcement", component: <CreateAnnouncementMain /> },
  { name: "document-repo", component: <DocumentRepoMain /> },
  { name: "folders-content", component: <FoldersContentMain /> },
  { name: "circulars", component: <CircularsMain /> },
  { name: "create-circular", component: <CircularForm /> },
  { name: "schedule-announcement", component: <ScheduleAnnouncementMain /> },
]

export const add_atm = [
  { name: "add-atms", component: <AddAtmForm /> },
  { name: 'all-atms', component: <AllAtm /> },
  { name: 'atm-details', component: <AtmView /> },
  { name: 'districtwise-atms', component: <DistrictWise /> }
]

export const incidents = [
  { name: "All_Incidents", component: <AllIncidentsMain /> },
  { name: "event-details", component: <EventDetailsMain /> },
  { name: "All_Incidents", component: <AllIncidentsMain /> },
  { name: "event-type-details", component: <EventTypeDetailsMain /> },
  { name: "create-incident", component: <IncidentForm /> },
  { name: "create-event", component: <EventForm /> },
  { name: "view-incidents", component: <ViewIncidetailsMain /> }
];

export const branches_routes_regs = [
  { name: "add-branch", component: <BranchForm /> },
  { name: "allbrancheslist", component: <AllBranches /> },
  { name: "DistrictWiseBranches", component: <DistrictWiseBranchesMain /> },
  { name: "add-bank", component: <BankForm /> },
  { name: "bank-list", component: <BankManagement /> },
  { name: "view-bank-details", component: <ViewBankDetailsMain /> },
  { name: "view-branch-details", component: <ViewBranchDetailsMain /> },
];

export const grievance_routes = [
  { name: "grievance", component: <GrievanceMain /> },
  { name: "raise-ticket", component: <RaiseTicketMain /> },
  { name: "view-raise-ticket", component: <ViewRiasedTicketMain /> },
  { name: "manage-sla", component: <ManageSlaMain /> },
];


export const RoutePlanning = [
  { name: "create-vehicle", component: <CreateVehicleHeader /> },
  { name: "exptected-route", component: <ExpectedTrackHeader /> },
  { name: "gps-tracking", component: <GpsTracking /> },
  { name: "gps-track-view", component: <GpsTrackView /> },
  { name: "planned-view", component: <PlannedViewHeader /> },
  { name: "travel-view", component: <GpsTravelViewHeader /> },
  { name: "trip-tracking", component: <TripTrackerHeader /> },
  { name: "trip-trakingView", component: <TripActionHeader /> },
  { name: "accident-history", component: <AccidentsHistory /> },
  

]

export const Geofencing  = [
   { name: "createfencing", component: <GeoFencing />},
   { name: "assignfencing", component: <AssignGeofence />}
]

export const FaceManagement = [
   { name: "userface-detection", component: <UserDetectionHeader /> }
]

export const OTA = [
  { name: "ota-dashboard", component: <OTAMain /> },
]
